module.exports = __webpack_public_path__ + "img/logo.64fa26bb.png";